<template>
  <div>
    <div class="wizard__header">
        <h3 v-html="this.header"></h3>
    </div>

    <div class="calculator wizard__calculator">
        <ul class="calculator__fields mobile--flex">
            <li class="calculator__field calculator__field--rate">
                <div class="calculator__inside">
                    <label class="calculator__label"># of Boxes Packed By Us <div class="tt-btn wizard__tooltip" title="We suggest the following number of boxes based on home size. 1-2 Bedrooms: 40 boxes, 3 Bedroom: 75 boxes, 4 bedroom: 110 boxes, 5 bedroom: 150 boxes.">?</div></label>
                    <numeric-input align="left" :min="0" controls-type="updown"  v-model="numberOfBoxesPackedByUs"></numeric-input>
                </div>
            </li>
            <li class="calculator__field calculator__field--space"></li>
            <li class="calculator__field calculator__field--hours">
                <div class="calculator__inside">
                    <label class="calculator__label"># of Moving Hours <div class="tt-btn wizard__tooltip" title="We suggest for accounting for 1 hour per bedroom. Don't forget to account for travel time as well!">?</div></label>
                    <numeric-input align="left" :min="3" :max="5" controls-type="updown"  v-model="numberOfMovingHours"></numeric-input>
                </div>
            </li>
        </ul>

        <div class="calculator__estimation">
            <div>
                <div class="calculator__estimation--value">
                    <span>$</span><span v-text="estimatedTotal"></span>
                </div>
                <div class="calculator__estimation--label">
                    estimated total cost
                </div>
            </div>
        </div>
    </div>

    <ul class="wizard__nav" v-if="onPrevious">
      <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--previous" @click.prevent="onPrevious">Previous</a></li>
      <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--next" @click.prevent="nextClickHandler">Review Details</a></li>
    </ul>
  </div>
</template>

<script>
import NumericInput from './NumericInput';
import { initialBoxCount } from '../classes/Globals';
  export default {
    props: {
        onResponse: {
            type: Function
        },

        onPrevious: {
            type: Function
        },

        header: {
            type: String
        },

        data: {
            type: Object,
            required: true
        },
    },

    data: () => ({
        numberOfBoxesPackedByUs: 1,
        numberOfMovingHours: 1,
        hourlyRate: 150,
        boxesInputSet: false
    }),

    computed: {
        estimatedTotal() {
            return (this.numberOfBoxesPackedByUs * 16) + (this.numberOfMovingHours * this.hourlyRate);
        }
    },

    watch: {
        data(newData, oldData) {
            if(newData.size !== undefined && this.boxesInputSet == false ) {
                this.numberOfBoxesPackedByUs = initialBoxCount[this.data.size];
                this.boxesInputSet = true;
            }
        },
        numberOfMovingHours: function(val) {
            if( isNaN(val) ) {
                this.numberOfMovingHours = 2;
            }
        },
        numberOfBoxesPackedByUs: function(val) {
            if( isNaN(val) ) {
                this.numberOfBoxesPackedByUs = 0;
            }
        }
    },
    methods: {
        hourKeypressHandler: function(evt) {
            let charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
                return false;
            }

            return true;
        },

        nextClickHandler() {
            let data = {
                numberOfBoxesPackedByUs: this.numberOfBoxesPackedByUs,
                numberOfMovingHours: this.numberOfMovingHours,
                estimatedTotal: `$${this.estimatedTotal}`
            };
            if (!isNaN(this.numberOfBoxesPackedByUs) && !isNaN(this.numberOfMovingHours)) {
                this.onResponse({
                    data,
                    response: true
                });
            }
        }
    },
    components: {
        NumericInput
    }
  };
</script>
